<div class="container pb-5 pt-3" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-2 pe-5">
        <a (click)="back()"><div class="p-2 ms-3"><i class="bi bi-chevron-left align-middle text-white"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-white"><b>Emergencias</b> médicas las 24hs</h1></div>
        <div class="p-2 pl-2 help" (click)="openhelp()"><i class="bi bi-info-circle  text-white"></i></div>
    </div>
    @if (helpOpen()) {
        <div class="row m-3 p-3 align-items-center" id="tooltip-pwa">
            <div class="col-auto"><i class="bi bi-info-circle" style="font-size: 1.8em;"></i></div>
            <div class="col">{{ helpText() }}</div>
            <div class="col-auto" (click)="openhelp()"><i class="bi bi-x-lg" style="font-size: 1.4em;"></i></div>
        </div>
    }

    <!-- Si es socio -->
    @if (asociadoCardio()) {
        <div class="row-cols-12 m-0 col-md-6 ms-md-5 me-md-5" style="margin: 0 auto !important;">
            <div class="row p-0">
                @if (envioFallido()) {
                    <div class="col col-lg-121 pt-4 orange-border m-3 rounded-3">
                        <div class="col-12 pb-4 text-center pt-4 title-emergencias-sup">NO PUDIMOS ENVIAR LA ALERTA</div>
                        <div class="msj-ambulancia text-center">
                            Llamá ahora mismo al <a href="tel:08102206060" class="text-tel-emergencia"><b>0810-220-6060</b></a>.
                        </div>
                        <div class="col-12 text-center p-4 pb-3 pt-3">
                            <a href="tel:08102206060" class="btn-cancel-alert pulse" style="text-decoration:none; display:inline-block;">LLAMAR AHORA</a>
                        </div>
                        <div class="col-12 text-center p-3 pb-5">
                            <div class="m-0 p-0 text-muteds text-white"
                                style="border: 1px solid #fff;padding: 5% !important;border-radius: 10px; cursor: pointer;"
                                (click)="reintentarEmergencia()">
                                REINTENTAR ALERTA AUTOMÁTICA
                            </div>
                        </div>
                    </div>
                } @else if (!alertaEnviada()) {
                    <div class="col col-lg-121 pt-4 orange-borders m-3 rounded-3 text-center">
                        <div class="col-12 text-center sos-center">
                            @if (!cancelEmergency()) {
                                <!-- <button type="button" class="btn-urgencias" (click)="armarEmergencia()" [class.arm-start]="arming()"> -->
                                    <img class="btn-urgencias" src="./assets/img/call-emergency.svg" (click)="armarEmergencia()" [class.arm-start]="arming()" style="width: 60%;">
                                <!-- </button> -->
                            } @else {
                                <div class="msj-ambulancia count fade-in-up"> {{ count() }} seg </div>
                            }
                        </div>
                        @if (!cancelEmergency()) {
                            <!-- <div class="col-12 pb-4 text-center pt-3 title-emergencias-inf">ALERTAR A AMBULANCIA</div> -->
                        } @else {
                            <div class="msj-ambulancia text-center"> Enviando alerta en.. </div>
                        }

                        @if (cancelEmergency()) {
                            <div class="col-12 text-center p-5 pb-5 pt-2">
                                <button type="button" class="btn-cancel-alert mt-5 pulse" (click)="cancelSolicitarEmergencia()">
                                    CANCELAR ALERTA
                                </button>
                            </div>
                        }
                    </div>
                } @else {
                    <div class="col col-lg-121 pt-4 orange-border m-3 rounded-3">
                        <div class="col-12 pb-4 text-center pt-4 title-emergencias-sup">ALERTA ENVIADA</div>
                        <div class="msj-ambulancia text-center"> El Centro de emergencias ya fue alertado. </div>
                        <div class="col-12 text-center p-5 pb-5 pt-2">
                        <div class="m-0 p-0 mt-5 text-muteds text-white"
                            style="border: 1px solid #fff;padding: 5% !important;border-radius: 10px; cursor: pointer;"
                            (click)="alertaEnviada.set(false); count.set(5); cancelEmergency.set(false);">
                            CERRAR
                        </div>
                        </div>
                    </div>
                }
            </div>
        </div>

        <div class="row-cols-12 m-0 col-md-6 ms-md-5 me-md-5 pt-3 mb-3" style="margin: 0 auto !important;">
            <div class="row justify-content-center g-4 ps-3 pe-3">
                <div class="col col-lg-3 d-flex flex-column align-items-center">
                    <a class="circle-btn text-center" href="tel:911" aria-label="Policía">
                        <span class="circle-btn__img" style="--icon:url('/assets/img/police-call.svg')"></span>
                    </a>
                    <div class="circle-label text-center text-white">POLICÍA</div>
                </div>

                <div class="col col-lg-3 d-flex flex-column align-items-center">
                    <a class="circle-btn text-center" href="tel:101" aria-label="Bomberos">
                        <span class="circle-btn__img" style="--icon:url('/assets/img/fireman-call.svg')"></span>
                    </a>
                    <div class="circle-label text-center text-white">BOMBEROS</div>
                </div>

                @if (xTelefonoEmergencia()) {
                    <div class="col col-lg-3 d-flex flex-column align-items-center">
                        <a class="circle-btn text-center" href="tel:{{xTelefonoEmergencia()}}" aria-label="Bomberos">
                            <span class="circle-btn__img" style="--icon:url('/assets/img/family-call.svg')"></span>
                        </a>
                        <div class="circle-label text-center text-white">FAMILIAR</div>
                    </div>
                }

                <!-- <div class="col col-lg-3 d-flex flex-column align-items-center">
                    <a class="circle-btn text-center" href="tel:70794848" aria-label="Bomberos">
                        <span class="circle-btn__img" style="--icon:url('/assets/img/cardio-call.svg')"></span>
                    </a>
                    <div class="circle-label text-center text-white">CARDIO</div>
                </div> -->

                @if (!xTelefonoEmergencia()) {
                <a [routerLink]="['/my-account-identidad']">
                    <div class="col-12 pb-4 text-center pt-4 subtitle-emergencias-blue" style="cursor:pointer;">
                        Clic acá para agregar contacto familiar de emergencia
                    </div>
                </a>
                }

                <div class="col-12 text-center p-3 pb-2 pt-2 ">
                    <div class="m-0 p-0 mt-0 pt-3 pb-3 text-muteds card-tel-emergencia text-white">
                        TAMBIÉN PODÉS COMUNICARTE AL <br> TELÉFONO DE EMERGENCIAS
                        <b><a href="tel:0810-220-6060" class="text-tel-emergencia">0810-220-6060</a></b>
                    </div>
                </div>
            </div>
        </div>
    }

    <!-- Si no es socio -->
    @if (!asociadoCardio()) {
        <div class="row-cols-12 m-0 col-md-6 ms-md-5 me-md-5 ps-3 pe-3" style="margin: 0 auto !important;">
            <div class="row p-0">
                <div class="col col-lg-121 pt-4 m-4 rounded-3 text-center">
                    <div class="logo-cardio-wrapper">
                        <img src="./assets/img/logo-cardio.svg" alt="Emergencias médicas las 24hs" class="img-fluid rounded logo-cardio">
                    </div>
                    <div class="col-12 pb-3 text-center pt-4 mt-4 title-emergencias-sup">EMERGENCIAS MÉDICAS <br><span class="title-emergencias-sup-naranja">LAS 24HS</span></div>
                    <div class="col-12 pb-3 text-center pt-3 subtitle-emergencias-sup subtitle-italic">Servicio exclusivo para socios</div>
                </div>

                <div class="col-12 text-center p-3 pb-2">
                    <div class="m-0 p-0 mt-0 pt-3 pb-2 text-muteds card-text-asociate">
                        <div class="col-12 pb-2 text-center title-asociarse">¡ASOCIATE AHORA!</div>
                        <div class="col-12 pb-2 text-center pt-0 subtitle-asociarse">A TRAVÉS DE NUESTROS CANALES OFICIALES</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row-cols-12 m-0 col-md-6 ms-md-5 me-md-5 pt-4 mb-3" style="margin: 0 auto !important;">
            <div class="row justify-content-center g-4 ps-3 pe-3 pb-5">
                <div class="col-4 col d-flex flex-column align-items-center">
                    <a class="circle-btn-whatsapp" href="https://api.whatsapp.com/send?phone=5491135222025&text=Hola%20quiero%20saber%20de%20su%20servicio" aria-label="Bomberos">
                        <span class="circle-btn__glyph-whatsapp" style="--icon:url('/assets/img/iso-whatsapp.svg')"></span>
                    </a>
                    <div class="circle-label text-center">whatsapp</div>
                </div>
                <div class="col-4 col d-flex flex-column align-items-center">
                    <a class="circle-btn-web" href="https://cardio24hs.com.ar/" aria-label="Bomberos">
                        <span class="circle-btn__glyph-web" style="--icon:url('/assets/img/iso-web.svg')"></span>
                    </a>
                    <div class="circle-label text-center">web</div>
                </div> 
                <div class="col-4 col d-flex flex-column align-items-center">
                    <a class="circle-btn-email" href="mailto:comunicacioncardio@gmail.com" aria-label="Bomberos">
                        <span class="circle-btn__glyph-email" style="--icon:url('/assets/img/iso-email.svg')"></span>
                    </a>
                    <div class="circle-label text-center">e-mail</div>
                </div>
            </div>

            <a [routerLink]="['/my-account-identidad']">
                <div class="col-12 pb-4 text-center pt-3 subtitle-emergencias-blue" style="cursor:pointer;">
                ¿Ya sos socio? Completá tu DNI o Nro. de Socio acá
                </div>
            </a>
        </div>
    }
    @if (error()) {
        <div class="alert alert-danger mt-4" role="alert">
            <small>{{ error() }}</small>
        </div>
    }
</div>